import React, { useEffect } from "react";

const Notification = ({ message, type, onClose }) => {
  // Auto-hide after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!message) return null;

  // --- DETERMINE STYLES BASED ON TYPE ---
  let backgroundColor = "#2196f3"; // Default Blue
  let icon = "ℹ️";

  if (type === "success") {
    backgroundColor = "#4caf50"; // Green
    icon = "✅";
  } else if (type === "error") {
    backgroundColor = "#ff5252"; // Light Red (for errors)
    icon = "⚠️";
  } else if (type === "danger") {
    backgroundColor = "#d32f2f"; // Darker Red (for deletes)
    icon = "🗑️";
  }

  const styles = {
    position: "fixed",
    top: "100px",
    right: "20px",
    backgroundColor: backgroundColor,
    color: "white",
    padding: "15px 25px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    zIndex: 10000,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "1rem",
    fontWeight: "bold",
    minWidth: "280px",
    animation: "slideIn 0.3s ease-out",
    borderLeft: "5px solid rgba(0,0,0,0.2)",
  };

  return (
    <div style={styles}>
      <span style={{ fontSize: "1.2rem" }}>{icon}</span>
      <span>{message}</span>
    </div>
  );
};

export default Notification;
